module.exports = __webpack_public_path__ + "assets/img/14_1596_big.cafd5be2.jpg";